<template>
    <div class="modal__buttons text-center text-md-right">
        <button v-if="!not_show_cancel" type="button" class="modal__buttons__item cancel" :data-dismiss="not_close_modal ? '' : 'modal'" aria-label="Close" v-html="`${cancel_text ? cancel_text : 'Cancel'}`" @click="cancel()"/>
        <button v-if="!done" class="modal__buttons__item" v-html="`${save_text ? save_text : `Save <img class='ml-2' width='15px' src='/assets/img/svg/add-w.svg' alt=''/>`} `" @click="save_and_close(); clicking();"/>
        <button v-else type="button" class="modal__buttons__item" v-html="`${save_text ? save_text : `Done`}`" data-dismiss="modal" aria-label="Close" @click="cancel()"/>
    </div>
</template>

<script>
import eventBus from '../plugins/eventBus'

export default {
    name: 'CentralLiteButtons',

    props: [
        'not_show_cancel',
        'cancel_text',
        'not_close_modal',
        'save_text',
        'done'
    ],
    data() {
        return {
            close: false,
            clicked: false
        }
    },

    async created() {

        eventBus.$on('spliceObject', () => {
            if (this.clicked)
            {
                this.revoke_loader_with_close('patch', this.close)
                this.close = false
                this.clicked = false
            }
        })

        eventBus.$on('unshiftObject', () => {
            if (this.clicked)
            {
                this.revoke_loader_with_close('post', this.close)
                this.close = false
                this.clicked = false
            }
        })
    },
    
    methods: {
        cancel()
        {
            this.$emit('Cancelation')
        },

        save_and_close()
        {
            this.close = true
            eventBus.$emit('save_and_new', !this.close )
        },

        clicking()
        {
            this.clicked = true
        }
    },
    
}
</script>